import { metaModel } from './Meta'
import moment from 'moment'

const PAYMENT_TIMEZONE_OFFSET = '-03:00'
const DATE_TIME_FORMAT = 'YYYY-MM-DDTHH:mm:ss.SSSZ'

export const TransactionModel = {
  list: ({ filters = {}, pagination = {} }) => {
    const meta = metaModel(pagination)

    const searchParams = TransactionModel.filters(filters)

    return { searchParams, pagination: meta }
  },
  filters: (filters = {}) => {
    const {
      initialDate,
      finalDate,
      reservation,
      aut,
      status
    } = filters

    return {
      initial_date: initialDate
        ? moment(initialDate).utcOffset(PAYMENT_TIMEZONE_OFFSET, true).startOf('day').format(DATE_TIME_FORMAT)
        : undefined,
      final_date: finalDate
        ? moment(finalDate).utcOffset(PAYMENT_TIMEZONE_OFFSET, true).endOf('day').format(DATE_TIME_FORMAT)
        : undefined,
      gateway: 'Braspag',
      reservations_codes: reservation && [reservation],
      aut: aut || undefined,
      status: status || undefined
    }
  },
  export: ({
    filters = {},
    emails = [],
    wantedFields = []
  }) => {
    return {
      ...TransactionModel.filters(filters),
      emails,
      wanted_fields: wantedFields
    }
  }
}
